import React, { useEffect, useState } from "react";
import StoreBoxOrderForm from "../../../forms/StoreBoxes";
import { GetBoxes } from "../../../services/box";
import { CreateStoreBoxOrders } from "../../../services/storeBoxOrder";

const CreateStoreBoxOrder = () => {
  const [boxes, setBoxes] = useState([]);
  const fetchBoxes = async () => {
    const { data } = await GetBoxes();
    if (data.result) {
      setBoxes(data.result);
    }
  };
  const handleSubmit = async (payload) => {
    const { data } = await CreateStoreBoxOrders(payload);
    if (data.result) {
      return data.result;
    }
  };
  useEffect(() => {
    fetchBoxes();
  }, []);
  return (
    <>
      <StoreBoxOrderForm
        boxes={boxes}
        onSubmit={handleSubmit}
        editable={true}
      />
    </>
  );
};

export default CreateStoreBoxOrder;
